import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'bcp-misakutei-gensan',
    title: 'BCP未策定減算は1%｜感染症と災害の両方がないと減算になる',
    description:
        'BCP未策定減算の減算率は、放課後等デイサービスなど通所系・訪問系は1%です。3%は障害児入所支援の率で、混同した解説が多く出回っています。感染症用と災害用の業務継続計画が両方そろって初めて減算を免れること、未策定だった月まで遡及して適用されることを、条文とQ&Aの原文つきで整理しました。',
    excerpt:
        '減算率を3%と書いている解説を見かけます。通所系は1%です。そして感染症用と災害用、片方でも欠ければ減算。しかも運営指導で見つかった時点からではなく、遡って適用されます。',
    category: '運営指導',
    keywords: ['BCP未策定減算', '放課後等デイサービス BCP', '業務継続計画 減算', 'BCP 減算率', '業務継続計画未策定減算'],
    publishedAt: '2026-09-09',
    updatedAt: '2026-09-09',
};
